export default "__VITE_ASSET__haRrpnTh__"